import styled from "styled-components";
export const UserWrapper = styled.div`
  background-color: #fff;
`;
